/* @flow */

import type { $Configuration } from '../../types/Configuration';
import type { $Dealer } from '../../types/Dealer';
import type { $DropdownOptions } from '../../types/DropdownOptions';
import type { $Translation } from '../../types/Translation';
import { ActivityTypeGroupsMarketPropertyKeys } from '../../constants/ActivityTypeGroups';
import { TemplateMarketPropertyKeys } from '../../templates/TemplateMarketProperties';
import { getActivityTypesSetFromDealersList } from '../../utils/DealerUtils';
import { getConfigurationMarketProperty } from '../../utils/WidgetUtils';
import { mapDealerActivityTypeToTranslation } from '../../utils/DealerUtils';

export function getFilterItemsList(
  dealersList: Array<$Dealer>, market: string, configuration: $Configuration, translations: Array<$Translation>
): $DropdownOptions {
  const activityTypeOptions: $DropdownOptions = {
    labels: [],
    values: []
  };

  const enabledActivityTypes: Array<string> = getConfigurationMarketProperty(
    configuration, market, TemplateMarketPropertyKeys.GEN_FILTERS_ACTIVITY_TYPES_ENABLED) || [];

  const dealerActivityTypes: Array<string> = getActivityTypesSetFromDealersList(dealersList);
  const activityTypesList: Array<string> = appendActivityTypeGroups(dealerActivityTypes, configuration, market);

  for (const activity of activityTypesList) {
    if (enabledActivityTypes.includes(activity)) {
      const activityTypeTranslation = mapDealerActivityTypeToTranslation(translations, activity);
      if (activityTypeTranslation) {
        activityTypeOptions.labels.push(activityTypeTranslation);
        activityTypeOptions.values.push(activity);
      }
    }
  }
  return sortFilterItemsList(activityTypeOptions);
}

export function sortFilterItemsList(activityTypeOptions: $DropdownOptions): $DropdownOptions {
  const options: $DropdownOptions = {
    labels: [],
    values: []
  };

  const list = [];
  for (let i = 0; i < activityTypeOptions.labels.length; i++) {
    list.push({
      label: activityTypeOptions.labels[i],
      value: activityTypeOptions.values[i]
    });
  }

  list.sort((a, b) => ((a.label < b.label) ? -1 : ((a.label == b.label) ? 0 : 1 )));

  for (let j = 0; j < list.length; j++) {
    options.labels[j] = list[j].label;
    options.values[j] = list[j].value;
  }

  return options;
}

export function appendActivityTypeGroups(
  dealerActivityTypes: Array<string>, configuration: $Configuration, market: string
): Array<string> {

  const activityTypeGroupsList: Array<string> = [];

  for (const [ propertyKey, groupCode ] of ActivityTypeGroupsMarketPropertyKeys) {
    if (appendActivityTypeGroup(propertyKey, dealerActivityTypes, configuration, market)) {
      activityTypeGroupsList.push(groupCode);
    }
  }

  return [
    ...activityTypeGroupsList,
    ...dealerActivityTypes
  ];
}

export function appendActivityTypeGroup(
  marketPropertyKey: string, dealerActivityTypes: Array<string>, configuration: $Configuration, market: string
): boolean {
  const activityTypeGroupMarketProperty: Array<string> =
    getConfigurationMarketProperty(configuration, market, marketPropertyKey) || [];

  return activityTypeGroupMarketProperty.filter((activity: string) =>
    dealerActivityTypes.includes(activity)).length > 0;
}
